<template>
    <div class="container-fluid p-4 min-vh-100 m-0" style="background: gray">
        <div v-if="loaded" class="container p-4 rounded-2 bg-white">
            <div class="row border-bottom border-1 border-primary">
                <div class="col">
                    <h4>Google Text-to-Speech API with Neorokõne for Estonia language and OpenAI streaming text test page</h4>
                </div>                
            </div>
            <div class="row pt-4 pb-2">
                <div class="col-4">
                    <h6>Language Codes:</h6>
                    <select v-model="code" id="code">
                        <option v-for="(c, index) in codes" :key="index" :value="c">{{ langName[c.split('-')[0]] }}</option>
                    </select>
                </div>
                <div class="col-4">
                    <img class="flag img-fluid" :src="flag" alt="Flag" />
                </div>
                <div class="col-4">
                    <h6>Voice names:</h6>
                    <select v-model="voiceName" id="voiceName">
                        <option v-for="(voice, index) in voices" :key="index" :value="voice.name">{{ voice.name }}</option>
                    </select>       
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <textarea ref="textarea" v-model="text" id="text" rows="10" class="w-100" style="font-size: 150%;"></textarea>
                </div>
            </div>
            <div class="row border-bottom border-1 border-primary py-2">
                <div class="col">
                    <button class="btn btn-primary" type="button" @click="send" :disabled="overlay">Speak!</button>
                </div>
                <div class="col">
                    <button class="btn btn-primary" type="button" @click="openai" :disabled="aiRun">Ask AI</button>
                </div>
                <div class="col">
                    <button class="btn btn-primary" type="button" @click="this.text=''">Clean</button>
                </div>
            </div>
            <div class="row pt-4 border-bottom border-1 border-primary py-2">
                <div class="col text-start">
                    <div class="row">
                        <div class="col">
                            <h6> Files: </h6>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <ul>
                                <li v-for="(add, i) in url" :key="i"><a :href="add" download>{{ add }}</a></li>
                            </ul>
                        </div>
                    </div>     
                </div>                
            </div>

            <div class="row pt-4">
                <div class="col text-start">
                    <h6>Flags:</h6>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <img v-for="(fg, index) in flags" :key="index" class="flag img-fluid m-2" :src="getFileUrl(`flags/${fg}.png`)" :alt="fg" :title="fg" />
                </div>
            </div>
      
        </div>
    </div>

    <div v-if="overlay" class="overlay">
        <div class="row position-absolute top-50 start-50 translate-middle">
            <div class="col">
                <div class="spinner-border text-success" style="width: 10rem; height: 10rem" role="status"></div>
            </div>
        </div>
        <div class="row position-absolute top-50 start-50 translate-middle">
            <div class="col">
                <span class="process justify-content-center fs-1 fw-bolder"> Working... </span>
            </div>
        </div>
    </div>

</template>

<script>
import axios from 'axios'
import { ref } from 'vue'
import langName from '../json/langByCodes.json'

export default {
    name: 'textToSpeech',
    data() {
        return {
            codes: [],
            voices: [],
            url: [],
            text: '',
            code: '',
            voiceName: null,
            langName: langName,
            backendURL: 'https://t2s.mella.ee:3000/api',
            // backendURL: 'https://192.168.1.243:3000/api',
            flag: '',
            flags: [],
            overlay: true,
            loaded: false,
            aiRun: false
        }
    },

    setup() {
        const textarea = ref()
        return {
            textarea
        }
    },

    created() {
        this.loadLangCodes()

        setTimeout(() => {
            this.codes.forEach(c => {
                this.flags.push(c.split('-')[1])       
            });
            this.flags = [...new Set(this.flags)];
            this.loaded = true
            this.overlay = false;
        }, 3000);
    },

    watch: {
        code: function() {
            const fc = this.code.split('-')[1];
            this.flag = this.getFileUrl(`flags/${fc}.png`)
            this.loadVoiceList()
        }
    },

    filters: {
        // country(code) {
        //     return 
        // },
    },

    mounted() {
        this.code = 'et-EE'
        // const code = this.code.split('-')[1]
        // console.log(countryCode[code])
    },

    methods: {

        async openai() {

            this.aiRun = true

            const req = {
                system: '',
                user: this.text
            };

            try {
                await axios.post(`${this.backendURL}/openaistr`, req);
            } catch (error) {
                console.error(error);               
            }

            // Make an HTTP request to the server's /openai route
            const eventSource = new EventSource(`${this.backendURL}/openai`);
            
            // Handle incoming data from the server
            eventSource.onmessage = (event) => {
                const data = event.data;
                if (data !== 'undefined') {
                    if (/[.!?]$/.test(this.text)) {
                        if (data[0] !== ' ') {
                            this.text += '\n\n'
                        }
                    } else if (/[,]$/.test(this.text)) {
                        if (data[0] !== ' ') {
                            this.text += '\n'
                        }
                    }
                    this.text += data;
                    
                    // Scroll the textarea to the bottom
                    this.textarea.scrollTop = this.textarea.scrollHeight;
                } else {
                    eventSource.close()
                    this.aiRun = false
                }
            };

            // Handle the connection being opened
            eventSource.onopen = () => {
                this.text += '\n\n';
            };
            // Handle any errors
            eventSource.onerror = (event) => {
                console.error('EventSource error:', event);
                this.aiRun = false
            };
        },

        async loadLangCodes() {
            await axios.get(`${this.backendURL}/langcodes`).then((response) => {
                this.codes = response.data
            }).catch((error) => {
                console.error(error);
            });
        },

        async loadVoiceList() {
            await axios.get(`${this.backendURL}/voices/${this.code}`).then((response) => {
                this.voices = response.data[0].voices;
                this.voiceName = response.data[0].voices[0].name
            }).catch((error) => {
                console.error(error);
            });
        },

        async send() {
            const data = {
                text: this.text,
                languageCode: this.code,
                code: this.code,
                voice: this.voiceName,
                speed: 1.0,
                pitch: 0.0,
                volumeGainDb: 0.0,
                sampleRateHertz: 24000,
                effectsProfileId: "",
            };

            this.overlay = true
            try {
                const response = await axios.post(`${this.backendURL}/synth`, data);
                const player = new Audio()
                player.src = response.data.url
                player.load()
                player.play()
                player.onended = function () {
                    player.remove(); //remove after playing to clean the Dom
                };
                this.url.push(response.data.url)
                this.overlay = false
            } catch (error) {
                this.overlay = false
                console.error(error);
            }
        },
    
        getFileUrl(filename) {
            return require("@/assets/" + filename)
        },

    },
            
}
</script>

<style>
*,
*:before,
*:after {
    box-sizing: border-box;
}

*:focus {
    outline: none;
}

body {
    min-height: 100vh;
}

 .flag {
    width: 150px; /* width of container */
/*    height: 100px; /* height of container */
    object-fit: cover;
    object-position: 25% 0%; 
/*    border-radius: 50%;*/
    border: 1px solid black;
}
</style>